import DgoContainer from "@/components/DGOContainer/DGOContainer.vue";
import DgoRow from "@/components/DGORow/DGORow.vue";
import DgoCol from "@/components/DGOCol/DGOCol.vue";
import NntPopup from "@/components/NNTPopup/NNTPopup.vue";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { mapMutations, mapState, mapActions, mapGetters } from "vuex";
import axios from 'axios';

export default {
    components: {
        FontAwesomeIcon,
        DgoContainer,
        NntPopup,
        DgoRow,
        DgoCol,
    },
    data() {
        return {
            translate: 0,
            mainHeight: 0,
            vw: Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0),
            vh: Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0),
        };
    },
    computed: {
        ...mapState('user', {
            user: 'data',
            successUser: 'success',
            errorUser: 'error',
            loadingUser: 'loading',
        }),
        ...mapState('notifications', {
            notifications: 'data',
            loadingNotifications: 'loading',
            successNotifications: 'success',
            errorNotifications: 'error',
        }),
        ...mapGetters('user', ['getUserFullName']),
        ...mapGetters('notifications', [
            'hasNotif', 'loadingToViewNotif',
            'successToViewNotif', 'errorToViewNotif',
            'toViewNotif',
        ]),
        getInitials() {
            const firstLastName = this.getUserFullName.split(' ');
            return `${firstLastName[0].charAt(0)}${firstLastName[firstLastName.length - 1].charAt(0)}`.toUpperCase();
        },
    },
    methods: {
        ...mapActions('user', ['requestUser']),
        ...mapActions('notifications', ['requestNotifications', 'changeNotificationState']),
        ...mapMutations('token', ['logout']),
        ...mapMutations('notifications', ['setViewedNotif']),
        observeViewport() {
            window.addEventListener('resize', ()=> {
                this.vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
                this.vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
                this.mainHeight = this.vh - (this.$refs.header.$el.offsetHeight + this.$refs.footer.$el.offsetHeight);
                this.translate = this.vw < 992 ? -260 : 0;
            });
        },
        onMenu() {
            if (this.vw < 992) { this.translate = this.translate < 0 ? 0 : -260; }
        },
        onNotifications() {
            if (this.vw < 992) {
                this.translate = this.translate < -260 ? -260 : -520;
            } else {
                this.translate = this.translate < 0 ? 0 : -260;
            }
        },
        doLogout() {
            this.logout();
            this.$router.push('/entrar/');
        },
        async sendToViewNotif(notification) {
            notification.visualized = true;
            this.setViewedNotif(notification);
            const newStateNotfi = await this.changeNotificationState();
            if (newStateNotfi) { this.requestNotifications(); }
        },
        registerNotifications() {
            window.OneSignal.push(async ()=> {
                let userIdNot = await OneSignal.getUserId() || '';
                
                if (!userIdNot) { window.OneSignal.showSlidedownPrompt(); }
                
                if (userIdNot.length && this.user.notification !== userIdNot) {
                    await axios.put(`${process.env.VUE_APP_BACKEND_API}/notification/`, { notification: userIdNot });
                }
                
                window.OneSignal.on('subscriptionChange', async (isSubscribed)=> {
                    if (isSubscribed) {
                        userIdNot = await OneSignal.getUserId();
                        await axios.put(`${process.env.VUE_APP_BACKEND_API}/notification/`, { notification: userIdNot });
                    }
                });
            });
        },
    },
    created() {
        this.observeViewport();
        this.translate = this.vw < 992 ? -260 : 0;
        this.requestUser();
        this.requestNotifications();
    },
    mounted() {
        this.registerNotifications();
    },
}
